import { module as modujs } from "modujs";

export default class extends modujs {
	constructor(m) {
		super(m);
	}

	init() {
		this.$input = this.el.querySelector(".c-file_input");
		this.$placeholder = this.$("placeholder")[0];

		this.placeholderText = this.$placeholder.textContent;

		this._changeHandler = this.change.bind(this);
		this.$input.addEventListener("change", this._changeHandler);

		this._resetHandler = this.reset.bind(this);
		document.addEventListener("wpcf7submit", this._resetHandler, false);
	}

	change() {
		var filename = this.$input.value.replace(/C:\\fakepath\\/i, "");

		this.reset();

		this.$placeholder.textContent = filename;
		this.el.classList.add("is-active");
	}

	reset() {
		this.$placeholder.textContent = this.placeholderText;
		this.el.classList.remove("is-active");
	}

	destroy() {
		this.$input.removeEventListener("change", this._changeHandler);
		document.removeEventListener("wpcf7submit", this._resetHandler, false);
	}
}
